document.addEventListener('DOMContentLoaded', () => {
  const tracking = window.SpillThatTracking || {
    push() {},
  };

  const cartRoot = document.querySelector('[data-launch-cart]');
  if (!cartRoot) return;

  tracking.push('view_cart', {
    path: window.location.pathname,
  });

  document.querySelectorAll('[data-track-event]').forEach((node) => {
    node.addEventListener('click', () => {
      tracking.push(node.dataset.trackEvent, {
        context: node.dataset.trackContext || null,
        label: node.dataset.trackLabel || node.textContent.trim(),
      });
    });
  });

  document.querySelectorAll('[data-subscribe-all]').forEach((button) => {
    button.addEventListener('click', async () => {
      let lines;
      try {
        lines = JSON.parse(button.dataset.subscribeLines || '[]');
      } catch (err) {
        lines = [];
      }
      if (!lines.length) return;

      const originalLabel = button.textContent;
      button.disabled = true;
      button.textContent = 'Subscribing…';

      try {
        for (const entry of lines) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ line: entry.line, selling_plan: entry.plan }),
          });
        }
        window.location.reload();
      } catch (err) {
        button.disabled = false;
        button.textContent = originalLabel;
        console.error('Subscribe-all failed', err);
      }
    });
  });
});
